import { render, staticRenderFns } from "./DataFieldsDeletionUndoneDialog.vue?vue&type=template&id=6af22a34"
import script from "./DataFieldsDeletionUndoneDialog.vue?vue&type=script&lang=ts"
export * from "./DataFieldsDeletionUndoneDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports